import { createFileRoute } from '@tanstack/react-router'
import { TicketSheetDialog } from '~/components/routes/project-tracking/ticket-sheet'
import { PROJECT_TRACKING_READ } from '~/lib/project-tracking'
import { withRoutePermissions } from '~/utils/rbac'

// Fiche ticket en route enfant : le deep-link partageable est le seul impératif de structure.
export const Route = createFileRoute('/_authenticated/project-tracking/$cardId')({
  staticData: {
    permission: PROJECT_TRACKING_READ,
  },
  component: TicketSheetRoute,
})
withRoutePermissions(Route)

function TicketSheetRoute() {
  const { cardId } = Route.useParams()
  const navigate = Route.useNavigate()
  // Fermer → retour au board (le dashboard reste monté sous la modale).
  return (
    <TicketSheetDialog cardId={cardId} onClose={() => void navigate({ to: '/project-tracking' })} />
  )
}
